const DATA_TEST_IDS = {
  mainLayout: 'layouts__main-layout',
} as const;

export default DATA_TEST_IDS;
